<template>
  <div>
    <ProfileBanner />
    <div class="container">
      <div class="row">
        <div
          class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12"
        >
          <div class="ui-block" ref="changePassword">
            <div class="ui-block-title">
              <h6 class="title">Change Password</h6>
            </div>
            <div class="ui-block-content">
              <!-- Change Password Form -->
              <response-message :data="errorData" />
              <form id="password_change_form" v-on:submit.prevent="changePassword">
                <div class="row">
                  <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="form-group label-floating is-empty with-button">
                      <label class="control-label">Confirm Current Password</label>
                      <button @click="() => { oldPassword_visibility === false ? oldPassword_visibility = true : oldPassword_visibility = false } " type="button" class="bg-grey">
                        <svg class="olymp-computer-icon">
                          <use v-if="oldPassword_visibility === false " xlink:href="/svg-icons/sprites/icons.svg#olymp-check-icon"></use>
                          <use v-else xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"></use>
                        </svg>
                      </button>
                      <input
                        class="form-control"
                        id="old_password"
                        v-model="formModel.old_password"
                        placeholder
                        :type=" oldPassword_visibility === false ? 'password' : 'text' "
                        autocomplete="current_password"
                      />
                    </div>
                  </div>

                  <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="form-group label-floating is-empty with-button">
                      <label class="control-label">Your New Password</label>
                      <button @click="() => { newPassword_visibility === false ? newPassword_visibility = true : newPassword_visibility = false } " type="button" class="bg-grey">
                        <svg class="olymp-computer-icon">
                          <use v-if="newPassword_visibility === false " xlink:href="/svg-icons/sprites/icons.svg#olymp-check-icon"></use>
                          <use v-else xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"></use>
                        </svg>
                      </button>
                      <input
                        class="form-control"
                        id="new_password"
                        v-model="formModel.new_password"
                        placeholder
                        :type=" newPassword_visibility === false ? 'password' : 'text' "
                        autocomplete="new_password"
                      />
                    </div>
                  </div>
                  <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="form-group label-floating is-empty with-button">
                      <label class="control-label">Confirm New Password</label>
                      <button @click="() => { confirmPassword_visibility === false ? confirmPassword_visibility = true : confirmPassword_visibility = false } " type="button" class="bg-grey">
                        <svg class="olymp-computer-icon">
                          <use v-if="confirmPassword_visibility === false " xlink:href="/svg-icons/sprites/icons.svg#olymp-check-icon"></use>
                          <use v-else xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"></use>
                        </svg>
                      </button>
                      <input
                        class="form-control"
                        id="confirm_password"
                        v-model="formModel.confirm_password"
                        placeholder
                        :type=" confirmPassword_visibility === false ? 'password' : 'text' "
                        autocomplete="old_password"
                      />
                    </div>
                  </div>

                  <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <button type="submit" class="btn bg-mdd btn-lg full-width">Change Password</button>
                  </div>
                </div>
              </form>

              <!-- ... end Change Password Form -->
            </div>
          </div>
        </div>

        <settingsBar :data="SettingsData" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import ProfileBanner from "../../components/Profile/ProfileBanner";
import settingsBar from "@/components/Profile/SettingsRightBar";
import Footer from "../../components/Home/Footer";
import {mapState} from "vuex";
import jquery from "jquery";

let $ = jquery;

var pageData = {
  projectName: "",
  userData: {},
  id: null,
  avatar: "",
  signedIn: false,
  SettingsData: {
    active: "Password"
  },
  formModel: {
    old_password: "",
    new_password: "",
    confirm_password: "",
  },
  oldPassword_visibility: false,
  newPassword_visibility: false,
  confirmPassword_visibility: false,
  errorData: {},
};
export default {
  name: "PasswordChange",
  data() {
    return pageData;
  },
  components: { settingsBar, Footer, ProfileBanner },
  computed: mapState({
    getAvatar: state => state.user.avatar,
    getUsername: state=> state.user.username,
    getUserDetails: state => state.user,
  }),
  methods: {
    showLoading() {
			let loader = this.$loader(this, this.$refs.changePassword, {loaderType: "spinner"});
			return loader;
		},
    // validate form fields
    validateForm() {
      if (
        this.formModel.old_password === "" &&
        this.formModel.new_password === "" &&
        this.formModel.confirm_password === ""
      ) {
        $("#password_change_form .label-floating").addClass('has-error')
        $("#password_change_form input").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry all fields are required",
          isError: true
        }
        return false;
      }else if (
        !this.$validate("password", this.formModel.old_password)
      ) {
        $("#password_change_form input#old_password").parent(".label-floating").addClass('has-error')
        $("#password_change_form input#old_password").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry all passwords must contain at least a number, symbol and a capital letter",
          isError: true
        }
        return false;
      }else if (
        !this.$validate("password", this.formModel.new_password)
      ) {
        $("#password_change_form #new_password").parent(".label-floating").addClass('has-error')
        $("#password_change_form input#new_password").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry all passwords must contain at least a number, symbol and a capital letter",
          isError: true
        }
        return false;
      }else if (
        !this.$validate("password", this.formModel.confirm_password)
      ) {
        $("#password_change_form #confirm_password").parent(".label-floating").addClass('has-error')
        $("#password_change_form input#confirm_password").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry all passwords must contain at least a number, symbol and a capital letter",
          isError: true
        }
        return false;
      }
      else if (
        this.formModel.confirm_password !== this.formModel.new_password
      ) {
        $("#password_change_form #confirm_password").parent(".label-floating").addClass('has-error')
        $("#password_change_form input#confirm_password").addClass('form-control-danger')
        this.errorData = {
          message: "Sorry do confirm your passwords again",
          isError: true
        }
        return false;
      }
      else {
        $("#password_change_form .label-floating").removeClass('has-error')
        $("#password_change_form input").removeClass('form-control-danger')
        return true;
      }
    },
    // submit the password change form
    changePassword() {
      // validate the form first
      if(this.validateForm()) {
        var loader = this.showLoading();
        const requestPayload = {
          old_password: this.formModel.old_password,
          password: this.formModel.new_password
        };
        if(this.getUserDetails.user_type === '1') {
          this.axios.post('/profile/update', requestPayload)
                  .then(response => {
                    this.errorData = {
                      message: "Your password has been changed, do make sure to note this",
                      isError: "success"
                    };
                    loader.hide();
                    return response;
                  })
                  .catch(error => {
                    // console.log(error)
                    this.errorData = {
                      message: "Sorry your old password does not match what we have",
                      isError: true
                    };
                    loader.hide();
                    return error;
                  })
        }else {
          this.axios.post('/business/update', requestPayload)
                  .then(response => {
                    this.errorData = {
                      message: "Your password has been changed, do make sure to note this",
                      isError: "success"
                    };
                    loader.hide();
                    return response;
                  })
                  .catch(error => {
                    // console.log(error)
                    this.errorData = {
                      message: "Sorry your old password does not match what we have",
                      isError: true
                    };
                    loader.hide();
                    return error;
                  })
        }
      }
    },
    checkUserData(userData) {
      if (userData !== "" || userData !== "undefined") {
        this.userData = JSON.parse(userData);
        this.signedIn = true;
      }
    },
  },
  mounted() {
    var userData = localStorage.fansData;

    if (userData) {
      this.checkUserData(userData);
    }
  },
};
</script>

<style>
  .ui-block {
    border:none !important;
  }
</style>
